module.exports = __webpack_public_path__ + "img/top-border-cockft.192d56c4.png";